// hooks
import { Fragment, useEffect, useState, useCallback } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useHttp from "hooks/use-http";

// routes
import { useParams, useNavigate } from "react-router-dom";

// material styles
import { Grid, Button, IconButton, TextField, Tooltip } from "@mui/material";

// material icons

import { Edit, Add } from "@mui/icons-material";

// components
import LoadingCM from "components/shared/Loading";
import DrawerCM from "components/shared/Drawer";
import TableCM from "components/shared/Table";
import BackButton from "components/shared/BackButton";
import PaginationCM from "components/shared/Pagination";

// helper
import Toast from "helper/toast";
import GenerateHeadCell from "helper/generate-head-cell";

// constants
import { PAGINATION_LIMIT } from "constants";

// request methods
import { getProductsCategoryRequest } from "api/requests/products";

// category head cells
const headCells = GenerateHeadCell("products_category_list");

export default function ProductsCategory() {
  const params = useParams();

  const navigate = useNavigate();

  const {
    request,
    loading,
    setLoading,
    isUploading,
    uploadProgress,
    setUploadProgress,
  } = useHttp(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm();

  // page state for pagination
  const [page, setPage] = useState(1);

  // category data state
  const [categoriesData, setCategoriesData] = useState({
    data: [],
    count: 0,
  });

  // states for filtered
  const [searchValue, setSearchValue] = useState("");
  const handleSearch = (e) => setSearchValue(e);

  // get all categories data
  const getCategoriesData = useCallback(async () => {
    setLoading(true);
    const res = await request({
      url: getProductsCategoryRequest,
      values: {
        skip: searchValue ? 0 : (page - 1) * PAGINATION_LIMIT,
        limit: searchValue ? 100 : PAGINATION_LIMIT,
        search: searchValue || null,
        is_parent: 1, // its just return all categories, not subcategories
      },
      isMulty: true,
    });

    setLoading(false);

    if (res) {
      if (res.data.count < 1) {
        return setCategoriesData({
          count: res.data.count,
          data: [{ content: "هیچ اطلاعاتی یافت نشد" }],
        });
      }
      let transformedData = res.data.data.map((items) => ({
        id: items.id,
        title: items.title,
        subCategory: (
          <IconButton
            sx={{
              color: "#1B569A",
            }}
            onClick={() => {
              navigate("/products/category/" + items.id + "/subcategory");
            }}
          >
            <Tooltip title="زیردسته ها" placement="top">
              <Add />
            </Tooltip>
          </IconButton>
        ),
        edit: (
          <IconButton
            sx={{
              color: "#1B569A",
            }}
            onClick={() => {
              navigate("/products/category/edit/" + items.id);
            }}
          >
            <Tooltip title="ویرایش" placement="top">
              <Edit />
            </Tooltip>
          </IconButton>
        ),
      }));

      setCategoriesData({
        data: transformedData,
        count: res.data.count,
      });
    }

    setLoading(false);
  }, [page, searchValue]);

  useEffect(() => {
    getCategoriesData();
  }, [getCategoriesData]);

  return (
    <DrawerCM title="لیست سردسته محصولات" onSearch={handleSearch}>
      {loading ? (
        <LoadingCM />
      ) : (
        <Fragment>
          <Grid container>
            <Grid item mt={3} xs={12}>
              <BackButton Route="/products" />
            </Grid>
          </Grid>

          <Grid container>
            <Grid item xs={12} my={2}>
              <TableCM
                title="لیست سردسته های محصولات"
                rows={categoriesData.data}
                headCells={headCells}
                page={page}
                addProductsCategory
                colspan={categoriesData.count === 0 ? "11" : ""}
                fontSize="12px"
                cellFontSize="12px"
              />
            </Grid>
            {categoriesData.count < 1 ? (
              ""
            ) : (
              <PaginationCM
                handleChange={(_, val) => setPage(val)}
                page={page}
                count={categoriesData.count}
              />
            )}
          </Grid>
        </Fragment>
      )}
    </DrawerCM>
  );
}
